import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import Header from "../components/common/Header";
import DataGridTable from "./common/DataGridTable";
import http from "../api/server.js";
import * as XLSX from 'xlsx';
import { GET_RMS_USER_CONTACT_COUNT, TRIGGER_EMAIL_TO_RESIDENT_USERS, GET_RMS_USER_INFO_LIST } from "../api/apiPath.js";

const LeadDashboard = () => {

  
    const [countData, setCountData] = useState({});
    const [searchText, setSearchText] = useState("");
    const [blockManager, setBlockManager] = useState('Block Manager');
    const [city, setCity] = useState('City');
    const [email, setEmail] = useState('Email');
    const [name, setName] = useState('Name');
    const [userInfoList, setUserInfoList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);

    useEffect(() => {
        const fetchContactCount = async () => {
            try {
                const response = await http.get(GET_RMS_USER_CONTACT_COUNT);
                setCountData(response.data);
            } catch (error) {
                console.error('Error fetching contact count:', error);
            }
        };

        fetchContactCount();
        fetchUserInfoList();

    }, []);

    const fetchUserInfoList = async () => {
        try {
            const response = await http.get(GET_RMS_USER_INFO_LIST);
            setUserInfoList(response.data);
        } catch (error) {
            console.error('Error fetching user info list:', error);
        }
    };
    const handleExportToExcel = () => {
  const exportData = filteredRows.map((row) => ({
    Name: `${row.firstName} ${row.lastName}`,
    Email: row.email,
    PhoneNumber: row.phoneNumber,
    PropertyDetails: `${row.propertyName}, ${row.apartmentOrHouseNo}, ${row.propertyAddress}, ${row.city}, ${row.postCode}`,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, 'resident-export.xlsx');
};


    const filteredRows = userInfoList.filter((row) => {
        const matchesSearch =
            !searchText ||
            row.firstName?.toLowerCase().includes(searchText.toLowerCase()) ||
             row.lastName?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.email?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.phoneNumber?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.propertyName?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.propertyAddress?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.apartmentOrHouseNo?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.postCode?.toLowerCase().includes(searchText.toLowerCase()) ||
            row.city?.toLowerCase().includes(searchText.toLowerCase());

        const matchesBlockManager =
            blockManager === 'Block Manager' || row.createdBy === blockManager;

        const matchesCity =
            city === 'City' || row.city === city;

        const matchesEmail =
            email === 'Email' || row.email === email;

        const matchesName =
            name === 'Name' || `${row.firstName} ${row.lastName}` === name;


        return (
            matchesSearch &&
            matchesBlockManager &&
            matchesCity &&
            matchesEmail &&
            matchesName
        );
    });

    const sendEmail = async (userIds = []) => {
        try {
            if (!Array.isArray(userIds) || userIds.length === 0) return;

            const response = await http.post(TRIGGER_EMAIL_TO_RESIDENT_USERS, userIds);

            if (!response.status || response.status >= 400) {
                throw new Error(`HTTP error! status: ${response?.status}`);
            }

            console.log("Email triggered successfully:", response.data);
        } catch (error) {
            console.error("Error triggering email:", error);
        }
    };


    return (
        <div className="bg-light min-vh-100">
            {/* Header */}
            <Header />
{showEmailConfirmation && (
        <div className="cancel-modal-overlay">
          <div className="cancel-modal-content">
            <i
              className="fa-solid fa-xmark fa-sm close-icon"
              style={{ cursor: "pointer" }}
              onClick={() => setShowEmailConfirmation(false)}
            ></i>

            <h2 className="cancel-modal-title m-5">
            Are you sure you want to send email?
            </h2>

            <div className="cancel-modal-actions">
              <Button
                variant=""
                type="reset"
                className="cancel-btn-go-back-go"
                size="sm"
                onClick={() => setShowEmailConfirmation(false)}
              >
               Cancel
              </Button>
              <Button
                variant=""
                type="button"
                className="cancel-btn-cancel"
                size="sm"
                onClick={() => {
                  sendEmail(selectedIds);
                  setShowEmailConfirmation(false)
                }}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      )}

            <Container fluid className="mt-4">
                {/* Stats Cards */}
                <Row className="g-3 mb-3">
                    <Col md={4}>
                        <div className="p-3 bg-white shadow-sm rounded text-center">
                            <span style={{ fontSize: "48px", fontWeight: "600" }}>{countData.emptyContactCount}</span>
                            <p className="mb-0">Residents without phone and email address</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="p-3 bg-white shadow-sm rounded text-center">
                            <span style={{ fontSize: "48px", fontWeight: "600" }}>{countData.availablePhoneCount}</span>
                            <p className="mb-0">Residents with phone only</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="p-3 bg-white shadow-sm rounded text-center">
                            <span style={{ fontSize: "48px", fontWeight: "600" }}>{countData.availableEmailCount}</span>
                            <p className="mb-0">Residents with email address only</p>
                        </div>
                    </Col>
                </Row>
                <div className="p-3 rounded-4" style={{ backgroundColor: "#0b1a3b" }}>
                    <Row className="g-3">
                        {/* Generate Letter */}
                        <Col md={6}>
                            <div
                                className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                                style={{ backgroundColor: "#1d2a4d" }}
                            >
                                <i className="fa-regular fa-file-text mb-3 vividOrangeColor" style={{ fontSize: "40px" }} />
                                <h6 className="text-white fw-bold">Generate Letter</h6>
                                <p className="text-light small mb-3">
                                    Create letters for residents
                                </p>
                                <Button
                                    variant="danger"
                                    className="px-4 fw-semibold"
                                    disabled={selectedIds.length === 0}
                                >
                                    Generate
                                </Button>
                            </div>
                        </Col>

                        {/* Send Email */}
                        <Col md={6}>
                            <div
                                className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                                style={{ backgroundColor: "#1d2a4d" }}
                            >
                                <i className="fa-regular fa-envelope mb-3 vividOrangeColor" style={{ fontSize: "40px" }} />
                                <h6 className="text-white fw-bold">Send email message</h6>
                                <p className="text-light small mb-3">
                                    Broadcast email communications for residents
                                  
                                </p>
                                <Button
                                    variant="danger"
                                    className="px-4 fw-semibold btn-danger"
                                    onClick={() => setShowEmailConfirmation(true)}
                                    disabled={selectedIds.length === 0}
                                >
                                    Send Email
                                </Button>
                                {/* <ol>
                                    {selectedIds.length > 0 && (
                                        selectedIds.map((id) => (
                                            <li className="text-danger" key={id}>{id}</li>
                                        ))
                                    )}
                                </ol> */}
                            </div>
                        </Col>
                    </Row>
                </div>


                <div className="dashboard-bar py-3">
                    <h2 className="mt-3 mb-3 text-start fw-bold">Resident Details</h2>
                    <div className="row align-items-center g-3">
                        {/* Search Bar */}
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>

                        {/* Dropdowns */}
                        <div className="col-6 col-md-2">
                            <select className="form-select form-control"
                                value={blockManager} onChange={(e) => setBlockManager(e.target.value)}>
                                <option>Block Manager</option>
                                 {[...new Set(userInfoList.map((user) => user.createdBy))].map((createdByItem, index) => (
                                    <option key={index} value={createdByItem}>{createdByItem}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-6 col-md-2">
                            <select className="form-select form-control" value={city} onChange={(e) => setCity(e.target.value)}>
                                <option value="City">City</option>
                                {[...new Set(userInfoList.map((user) => user.city))].map((cityItem, index) => (
                                    <option key={index} value={cityItem}>{cityItem}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-6 col-md-2">
                            <select className="form-select form-control" value={email} onChange={(e) => setEmail(e.target.value)}>
                                <option value="Email">Email</option>
                                {[...new Set(userInfoList.map((user) => user.email))].map((emailItem, index) => (
                                    <option key={index} value={emailItem}>{emailItem}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-6 col-md-2">
                            <select className="form-select form-control" value={name} onChange={(e) => setName(e.target.value)}>
                                <option value="Name">Name</option>
                                {[...new Set(userInfoList.map((user) => `${user.firstName} ${user.lastName}`))].map((fullName, index) => (
                                    <option key={index} value={fullName}>{fullName}</option>
                                ))}


                            </select>
                        </div>


                        {/* Export Button */}
                        <div className="col-md-1 text-end">
                            <button className="btn btn-primary export-btn form-control"
                            onClick={() => handleExportToExcel()}>
                                <i className="fa-solid fa-download"></i>Export
                            </button>
                        </div>
                    </div>
                </div>

                <DataGridTable
                    tableData={filteredRows}
                    setSelectedIds={setSelectedIds}
                    setShowEmailConfirmation={setShowEmailConfirmation}
                    module="leadDashboard"
                />



            </Container>
        </div>
    );
}
export default LeadDashboard;
